module.exports = __webpack_public_path__ + "images/cd5580cb7891358cfcca3ee4e7be009c.svg";